import { styled } from '@goodfynd/theme';
import { Link } from '@goodfynd/ui';

import { CARD_IMAGE_DIMENSIONS } from '../../../hooks/useVendorSearch/VendorImages/dimensions';

export const CARD_HEIGHT = 268;
export const CARD_WIDTH = CARD_IMAGE_DIMENSIONS.CONTAINER_WIDTH;

export const StyledCardContainer = styled('div', {
  borderRadius: 8,
  cursor: 'pointer',
  maxWidth: CARD_WIDTH,
  '&:hover': {
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
  },
});

export const StyledCardContent = styled('div', {
  borderBottomLeftRadius: 8,
  borderBottomRightRadius: 8,
  maxWidth: CARD_WIDTH,
  paddingBottom: 12,
  paddingLeft: 8,
  paddingTop: 12,
  '@md': {
    maxWidth: CARD_IMAGE_DIMENSIONS.MD.CONTAINER_WIDTH,
  },
});

export const StyledLink = styled(Link, {
  ':hover': {
    color: 'initial',
  },
});

export const StyledQuickInfo = styled('div', {
  alignItems: 'center',
  display: 'flex',
});
